import React, { useCallback } from 'react';
import { apiHolder as api, apis } from 'api';
import { MAIL_MENU_ITEM } from '../../common/constant';
import MailMenuBase from '../../common/components/MailMenu/MailMenuBase/MailMenuBase';
import useState2RM from '../../hooks/useState2ReduxMock';
import { useAppSelector } from '@web-common/state/createStore';
import { isMailDiff } from '@web-mail/utils/mailCompare';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailMenu = props => {
    const { activeMailId, visible, setVisible, selectedKeys, selected, domProps } = props;
    const item = useAppSelector(state => {
        var _a, _b;
        if ((_a = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _a === void 0 ? void 0 : _a.mailEntities) {
            const id = Array.isArray(activeMailId) ? activeMailId[0] : activeMailId;
            return (_b = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _b === void 0 ? void 0 : _b.mailEntities[id];
        }
    }, (old, newValue) => {
        return !isMailDiff(old, newValue);
    });
    if (!activeMailId || activeMailId.length == 0)
        return React.createElement(React.Fragment, null);
    const [mailMenuItemState, setMailMenuItemState] = useState2RM('mailMenuItemState');
    const handelIconMenuBeforeClick = useCallback((config, data) => {
        let name = config === null || config === void 0 ? void 0 : config.name;
        if (typeof (config === null || config === void 0 ? void 0 : config.name) === 'function') {
            const _name = config === null || config === void 0 ? void 0 : config.name(data);
            if (typeof _name === 'string') {
                name = _name;
            }
        }
        trackApi.track('pcMail_click_ReplyButton_mailHead_mailList', { buttonName: name });
    }, []);
    return visible ? (React.createElement(MailMenuBase, { mail: item, beforeMenuItemClick: handelIconMenuBeforeClick, onMenuClick: () => {
            setVisible(false);
        }, menu: [
            {
                key: MAIL_MENU_ITEM.TOP,
                show: (mail, defaultShow) => {
                    if (selected !== 'ALL') {
                        return false;
                    }
                    if (defaultShow) {
                        return defaultShow(mail);
                    }
                    return true;
                },
            },
        ], menuItemStateMap: mailMenuItemState, onMenuItemStateChange: (menuId, data) => {
            var _a, _b;
            return setMailMenuItemState(Object.assign(Object.assign({}, mailMenuItemState), { [(_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id]: Object.assign(Object.assign({}, (mailMenuItemState[(_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.id] || {})), { [menuId]: data }) }));
        }, domProps: domProps })) : (React.createElement(React.Fragment, null));
};
export default MailMenu;
